import { useCallback, useState } from 'react';

/**
 * The sources the reader turned off with the source pills (design b1). Only the screen changes:
 * the server still reads every source.
 */
export function useSourceFilter() {
  const [off, setOff] = useState<string[]>([]);
  const toggle = useCallback((integrationType: string) => {
    setOff((current) =>
      current.includes(integrationType)
        ? current.filter((one) => one !== integrationType)
        : [...current, integrationType]
    );
  }, []);
  return { off, toggle };
}
